import IApplicationState from 'app/types/state';

export function getCurrentInvitation(state: IApplicationState) {
  if (state.invitations.invitationsById !== undefined && state.invitations.currentInvitationId !== undefined) {
    return state.invitations.invitationsById[state.invitations.currentInvitationId];
  }
  return {};
}

export function getInvitations(state: IApplicationState) {
  return {
    ...state.invitations,
    currentInvitation: {
      ...getCurrentInvitation(state),
    },
  };
}
export default null;
